var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#c3e2fa"}},[_c('Header'),_c('router-view',{staticStyle:{"min-height":"55.5vh","width":"1200px","margin":"0 auto"}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }